import { RiPrinterFill } from '@remixicon/react'
import { useRef } from 'react'
import { Link } from 'react-router'

import type { Order } from '@/api/orders/orders-types'
import { PACKING_PREVIEW_WIDTH, PackingListOrder } from '@/components/stickers/packing-list-document'
import { PageSizeToggle } from '@/components/stickers/packing-list-page-size-toggle'
import { usePackingListPrint } from '@/components/stickers/use-packing-list-print'
import { Button } from '@/components/ui/button'

interface PackingListStickersProps {
  order: Order
}

export const PackingListStickers = ({ order }: PackingListStickersProps) => {
  const contentRef = useRef<HTMLDivElement>(null)
  const { pageSize, print, setPageSize } = usePackingListPrint(contentRef)

  return (
    <div className='flex w-full flex-col items-center gap-3'>
      <div className='no-print flex flex-wrap items-center justify-center gap-2'>
        <Button
          type='button'
          onClick={() => print()}
        >
          <RiPrinterFill />
          Print packing list
        </Button>
        <PageSizeToggle
          value={pageSize}
          onChange={setPageSize}
        />
        <Button
          asChild
          variant='outline'
        >
          <Link to={`/packing-list/${order.autoid}`}>Open on phone view</Link>
        </Button>
      </div>

      <div
        ref={contentRef}
        className='packing-doc bg-white-100 max-w-full rounded-md border p-3 text-[#000]'
        style={{ width: PACKING_PREVIEW_WIDTH[pageSize] }}
      >
        <PackingListOrder
          order={order}
          pageSize={pageSize}
        />
      </div>
    </div>
  )
}
